'use client'
import {
  context_default
} from "./chunk-7NFFA5PE.mjs";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-BBBOZKTU.mjs";

// src/context/root/provider.tsx
import { useLayoutEffect, useMemo } from "react";
import { setCaptchaContext } from "@wbk/api/grecaptcha";
import { jsx } from "react/jsx-runtime";
var WbkConfigProvider = (_a) => {
  var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
  var _a2, _b2, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r;
  const locale = ((_a2 = props.router) == null ? void 0 : _a2.locale) || "en";
  const captchaProvider = (_b2 = props.captcha) == null ? void 0 : _b2.provider;
  useLayoutEffect(() => {
    setCaptchaContext({ provider: captchaProvider, locale });
  }, [captchaProvider, locale]);
  const handlePush = (url) => {
    window.location.assign(url);
  };
  const handleReplace = (url) => {
    window.location.replace(url);
  };
  const search = useMemo(() => {
    if (typeof window === "undefined") return new URLSearchParams();
    return new URLSearchParams(window.location.search);
  }, []);
  const handleSetSearch = (search2, options) => {
    const searchParams = typeof window === "undefined" ? new URLSearchParams() : new URLSearchParams(window.location.search);
    for (const key in search2) {
      const value = search2[key];
      if (!value) {
        searchParams.delete(key);
        continue;
      }
      if (Array.isArray(value)) {
        value.forEach((v) => {
          searchParams.append(key, v);
        });
      } else {
        searchParams.set(key, value);
      }
    }
    const target = `${window.location.pathname}?${searchParams.toString()}`;
    if (options == null ? void 0 : options.replace) {
      handleReplace(target);
    } else {
      handlePush(target);
    }
  };
  const handleSetLocale = (newLocale) => {
    const pathWithoutLocale = window.location.pathname.replace(`/${locale}`, "");
    window.history.pushState({}, "", `/${newLocale}${pathWithoutLocale}`);
  };
  return /* @__PURE__ */ jsx(
    context_default.Provider,
    {
      value: __spreadProps(__spreadValues({}, props), {
        router: {
          Link: ((_c = props.router) == null ? void 0 : _c.Link) || "a",
          push: ((_d = props.router) == null ? void 0 : _d.push) || handlePush,
          replace: ((_e = props.router) == null ? void 0 : _e.replace) || handleReplace,
          locale,
          dir: locale === "ar" ? "rtl" : "ltr",
          languages: props.i18n.languages,
          pathname: ((_f = props.router) == null ? void 0 : _f.pathname) || "",
          search: ((_g = props.router) == null ? void 0 : _g.search) || search,
          params: ((_h = props.router) == null ? void 0 : _h.params) || {},
          baseUrl: ((_i = props.router) == null ? void 0 : _i.baseUrl) || void 0,
          setSearch: ((_j = props.router) == null ? void 0 : _j.setSearch) || handleSetSearch,
          setLocale: ((_k = props.router) == null ? void 0 : _k.setLocale) || handleSetLocale
        },
        checkout: __spreadProps(__spreadValues({}, props.checkout), {
          requiredUserProps: ((_l = props.checkout) == null ? void 0 : _l.requiredUserProps) || [
            "dob",
            "gender",
            "country",
            "nationality",
            "city"
          ],
          sendTicketsTerms: !!((_m = props.checkout) == null ? void 0 : _m.sendTicketsTerms)
        }),
        logo: props.logo,
        appLoadingComponent: props.appLoadingComponent,
        showTerms: (_n = props.showTerms) != null ? _n : true,
        date: {
          timeZone: (_p = (_o = props.date) == null ? void 0 : _o.timeZone) != null ? _p : "Asia/Riyadh",
          hour12: (_r = (_q = props.date) == null ? void 0 : _q.hour12) != null ? _r : true
        }
      }),
      children
    }
  );
};

export {
  WbkConfigProvider
};
//# sourceMappingURL=chunk-JV2H6IZZ.mjs.map